module.exports = __webpack_public_path__ + "img/mobDashInact.44151c78.svg";